<script>

	import P5 from 'p5-svelte';
	import { fade } from 'svelte/transition';
	import _ from 'lodash';
	import { onMount } from 'svelte';

	let image_data = {};
	let images = [];
	let raw_img = [];
	let tags = [];
	let transitionout = false;
	let readytodraw = false;
	let drawing = false;
	let landing = false;
	let show_about = false;
	let readytosift = false;
	let frame;

	let datafetch = ISPROD ? 'http://imd.emenel.ca/scripts/imagedump.py' : 'data.json';

	const urlParams = new URLSearchParams(window.location.search);
    const is_resift = urlParams.has('resift');

	onMount(() => {
		if (is_resift) {
			start();
		} else {
			landing = true
		}
	});

	function get_data () {
		fetch(datafetch)
		.then(response => response.json())
		.then(data => {
			image_data = _.sampleSize(data, 10);		
			tags = _.uniq(_.flatMap(image_data, function(v){
				return v.category;
			}));
			// console.log(image_data);
			setTimeout(() => {readytodraw = true}, 2000);
		});
	}

	function start (ev) {
		landing = false;
		readytosift = true;
		get_data();
	}

	function about (ev) {
		show_about = true;
	}

	function close_about (ev) {
		setTimeout(() => {show_about = false;}, 100);
	}

	function resift (ev) {
		setTimeout(function() {window.location.assign("index.html?resift=true");}, 3200);
		transitionout = true;
	}

	const sketch = (p) => {

		p.preload = () => {
			image_data.forEach(e => {
				raw_img.push(p.loadImage('http://imd.emenel.ca/images/'+e.category+'/'+e.file));
			});
		}

		p.setup = () => {
			p.createCanvas(p.windowWidth, p.windowHeight, p.WEBGL);
			p.cursor(p.CROSS);
			for (let i = 0; i < raw_img.length; i++) {
				images.push(new ImageRend(raw_img[i], image_data[i].category, i));
			}
			drawing = true;
		}

		p.draw = () => {
			p.background(0);

			let locX = p.mouseX - p.width / 2;
			let locY = p.mouseY - p.height / 2;
			p.ambientLight(30);
			// p.spotLight(250, 250, 250, locX, locY, 2200, 0, 0, -1, Math.PI, 2);
			let m = p.map(p.frameCount, 0, 100, 0, 250, true);
			p.spotLight(m, m, m, locX, locY, 2200, 0, 0, -1, Math.PI, 2);
			p.noStroke();
			
			p.fill(200,200,200);
			p.plane(p.width, p.height)

			for (let i = 0; i < images.length; i++) {
				images[i].display(locX, locY, p.frameCount);
			}
		}

		p.windowResized = () => {
			debouncedResize();
		}

		var debouncedResize = _.debounce(function () {
			p.resizeCanvas(p.windowWidth, p.windowHeight, false);
		}, 200);
		
		function ImageRend(im, tag, num) {
			this.num = num;
			this.sizemod = _.random(2,6);
			this.width = im.width / this.sizemod;
			this.height = im.height / this.sizemod;
			this.tag = tag;
			this.x = _.random((-p.width)+this.width, p.width-this.width);
			this.y = _.random((-p.height)+this.height, p.height-this.height);
			this.z = _.random(10, 100);
			this.r = _.sample([0,0,0,p.PI,p.PI/2,-(p.PI/2),-(p.PI)]);
			this.o = 0;

			this.display = function (cx, cy, iter) {
				p.push();
				p.imageMode(p.CENTER);
				p.translate(this.x + (this.x - cx*10)/10, this.y + (this.y - cy*10)/10, this.z);
				p.texture(im);
				p.plane(this.width, this.height);
				p.pop();
			}
		}

	}
</script>

{#if !transitionout}
<main out:fade="{{duration: 3000}}">
	<!-- {#if show_about}
		<div transition:fade id="about-text">
			<a href="#close" on:click|preventDefault={close_about}>Close</a>
			<p>yadda</p>
		</div>
	{/if} -->

	{#if readytodraw}
		<P5 {sketch} />
	{/if}
	
	{#if landing}
		<div transition:fade id="landing">
			<h1>Sift</h1>
			<p>Rooted in archival infrastructures and practices of storage, arranging and sorting, artists <a href="https://samueldelange.com" class="name">Samuel de Lange</a> and <a href="http://www.jacksonklie.com" class="name">Jackson Klie</a> create a repository of research and reference materials which engages in the gestures of sifting through information. The materials available online provide insight into the research process of de Lange and Klie’s spring 2022 exhibition at <a href="https://www.gallery44.org" class="name">Gallery 44</a>. Web platform design by <a href="https://emenel.ca" class="name">Matt Nish-Lapidus.</a></p>
			<p class="note">Note: This site requires a modern browser, Javascript, and loads large images. It is best on laptop and desktop computers.</p>
			<a class="start" href="index.html" transition:fade="{{delay: 200, duration: 2000}}" on:click|preventDefault={start}>Sift now</a>
		</div>
	{/if}

	{#if readytosift}
		<div id="controls">
			<div transition:fade id="title-links">
				<h1>Sift</h1>
				<span class="context-links">
					<!-- <a href="about" on:click|preventDefault={about}>About this project</a>  -->
					<a href="https://www.gallery44.org">Gallery 44</a>
				</span>
			</div>
			
			<div transition:fade id="tags">
				{#if drawing}
					<span id="resift"><a href="index.html?resift=true" on:click|preventDefault={resift}>Sift again</a></span>
				{/if}
				<span id="p5_loading">Sifting ... </span>
				{#each tags as tag}
					<span in:fade>{tag}</span>
				{/each}
			</div>
		</div>
	{/if}
</main>
{/if}
